
import hinweiseStorage from "../storage/hinweise-storage";

export default function reducer(state = hinweiseStorage, action) {
  switch (action.type) {    
    case 'SET_HINWEISE': {
      let newState = { ...state };
      newState.setHinweise(action.payload);
      return newState;
    }
    default: return state;
  }
}